<!--
 * @Author: Merlin
 * @Date: 2025-04-11 10:16:19
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-29 10:52:40
 * @Description: 
-->
<template>
    <q-dialog class="game-dialog"
        full-width
        full-height
        :position="'top'"
        @hide="handleHide"
        style="background:#1c2532;"
        :transition-show="'slide-left'"
        :transition-hide="'slide-right'"
        :transition-duration="300"
        :model-value="show"
    >
        <div class="page-wrap" :ref="el => oPageWrap=el">
            <div class="top-bar">
                <div class="row01">
                    <div>
                        <em class="title">
                            {{ $t('notificationPage.notification') }}
                        </em>
                        <span class="active-type">
                            <DropDown class="drop-down" v-model="iDataScope" :options="aDataScopeOptions" shadow
                                @update:model-value="handleSelectGame">
                            </DropDown>
                        </span>
                    </div>
                    <q-btn class="popup-close" icon="close" color="white" flat round dense v-close-popup />
                </div>

                <div class="tab-wrap">
                    <span v-for="(cur, idx) of aTabList" :key="idx" @click="changeTab(idx)" class="tab-item"
                        :class="{
                            'active': idx === iTabActive,
                        }"
                    >
                        {{ $t(cur.i18nKey) }}
                        <i class="number" v-show="userStore.unread[cur.type] > 0">
                            {{ userStore.unread[cur.type] }}
                        </i>
                    </span>
                </div>
            </div>
            <!--
                ↑ 标题
                ↓ 列表 
            -->
            <!-- 网络异常 故障页 -->
            <div v-if="isError && !oActive.aNotiList.length"
                class="text-[#fff] main-data flex flex-col items-center mt-[30px] px-[16px]"
            >
                <img src="@/assets/imgs/500_err.png" class="w-[165px] h-[165px]">
                <div class="text-[#fff]">
                    {{ $t('notificationPage.NetworkError') }}
                </div>
            </div>

            <div v-else>
                <div v-if="oActive.aNotiList.length" class="px-[16px]">
                    <ul class="main-data">
                        <li class="one-card" v-for="(cur, idx) of oActive.aNotiList" :key="cur._id">
                            <div class="msg-top">
                                <span class="time-bar">
                                    <time>
                                        {{ moment(cur.date).format(sDateFormat) }}
                                    </time>
                                    <!-- ↓ 新消息标记 -->
                                    <i class="new-badge" v-if="cur.is_read == 0">
                                        {{ $t('notificationPage.new') }}
                                    </i>
                                </span>
                                <h5 class="title break-all">
                                    {{ cur.title }}
                                </h5>
                                <div class="picture relative">
                                    <SkeletonLoader v-if="loading[idx]" type="flow" height="120px"
                                        class="mb-3 rounded-lg" />
                                    <!-- 图片 -->
                                    <img @load="handleImageLoad(idx)" :src="cur.picture || 'default'"
                                        @error="(e) => handleImageError(e, idx)" class="w-full h-full object-cover "
                                        :class="{ invisible: loading[idx] }" />
                                </div>
                                <!-- 显示2行 -->
                                <div class="relative text-white" :class="{ 'pb-[20px]': cur.isExpanded }">
                                    <div :ref="(el) => initTextEl(el, idx)"
                                        class="break-all overflow-hidden transition-all duration-300 "
                                        :class="{ 'line-clamp-none': cur.isExpanded, 'line-clamp-2': !cur.isExpanded }">
                                        {{ cur.content }}
                                    </div>
                                    <button v-if="cur.showExpandButton" @click=" cur.isExpanded = !cur.isExpanded"
                                        class="text-blue-500 text-sm  text-right absolute right-0 pl-[15px]"
                                        :class="{ 'mt-[-20px]': !cur.isExpanded, 'bg-[rgba(28,37,50,6)]': !cur.isExpanded }">
                                        {{ !cur.isExpanded ? $t('notificationPage.shallAll') : $t('notificationPage.Hide') }}
                                        <QIcon :name="cur.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down'" />
                                    </button>
                                </div>
                                <!-- <p class="content line-clamp-3">
                                    {{ cur.content }}
                                </p> -->
                            </div>
                            <!-- 上下分界 -->
                            <div class="msg-bottom">
                                <button class="join" v-if="cur.link" @click="fnJoin(cur)">
                                    {{ $t('notificationPage.join') }}
                                    <IconSvgUse class="inline-block" use="icon-arrow-right" size="1em" />
                                </button>
                                <span v-else></span>
                                <!-- ↑ 空元素，在左边占位 -->
                                <!-- ↓ 左右分界 -->
                                <button class="mark-as-read" v-show="cur.is_read == 0" @click="fnMarkOneAsRead(cur)">
                                    {{ $t('notificationPage.setOneAsRead') }}
                                    <IconSvgUse class="inline-block" use="icon-vote" size="1em" />
                                </button>
                            </div>
                        </li>
                    </ul>

                    <!-- 
                        ↑ 列表结束
                        ↓ 最下方
                    -->
                    <div class="bottom-tip">
                        <span class="loading" v-if="isError">
                            {{ $t('notificationPage.NetworkError') }}
                        </span>
                        <span class="loading" v-else-if="oActive.pending">
                            {{ $t('notificationPage.loading') }}
                        </span>
                        <span class="no-more-go-back" v-else>
                            <span>
                                {{ $t('notificationPage.noMoreData') }}&nbsp;
                            </span>
                            <button @click="scrollToTop" v-if="oActive.aNotiList.length >= 3">
                                {{ $t('notificationPage.goTop') }}
                            </button>
                        </span>
                    </div>
                    <!-- ↓ 按钮 01 -->
                    <button class="set-all-read"
                        v-click-and-rest
                        @click="fnMarkAllAsRead"
                        v-if="oActive.aNotiList.find(cur => cur.is_read == 0)"
                        style="opacity:1 !important;"
                    >
                        {{ $t('notificationPage.setAllAsRead') }}
                    </button>
                </div>
                <!-- 没有数据 -->
                <div v-else class="text-[#fff] main-data flex flex-col items-center mt-[30px] px-[16px]">
                    <img src="@/assets/imgs/noData.png" class="w-[165px] h-[165px]">
                    <div>
                        {{ $t('notificationPage.noData') }}
                    </div>
                </div>
            </div>
        </div>
    </q-dialog>
</template>

<script lang="ts" setup>
import { Dialog } from 'quasar';
import { useUserStore } from '~/stores/user';
import { useMailSocket } from '@/socket/mail/index';
import { MailType, MailTypeNum } from '@/socket/mail/dto/index';
import moment from 'moment';
import defaultImage from '@/assets/imgs/error.png'
import { useAuthStore } from '~/stores/auth';

const {
    EMIT_MAIL_INFO,
    EMIT_MAIL_SET_READ,
} = useMailSocket();
const userStore = useUserStore();

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    }
})
const emits = defineEmits(['close', 'update:show'])

const authStore = useAuthStore();
const aTabList = reactive([{
    type: MailType.system,
    iTypeMark: MailTypeNum.system, // 0=系统类消息 
    i18nKey: 'notificationPage.typePlatform',
    aNotiList: [],
    requestID: 0,
    pending: true,
    noMoreNotifications: false,
    typeLastSearch: '', // 标记上次查询的数据类型，是未读还是全部 
}, {
    type: MailType.person,
    iTypeMark: MailTypeNum.person, // 1=个人类消息 
    i18nKey: 'notificationPage.typePersonal',
    aNotiList: [],
    requestID: 0,
    pending: true,
    noMoreNotifications: false,
    typeLastSearch: '',
}]);


const { t: $tFn } = useNuxtApp().$i18n;
const iTabActive = ref(0);
const oPageWrap = ref(null); // 保存 dom 
const iST = Date.now();

const aDataScopeOptions = reactive([{
    name: $tFn('notificationPage.viewAll'),
    label: $tFn('notificationPage.viewAll'),
    value: 'all',
}, {
    name: $tFn('notificationPage.unread'),
    label: $tFn('notificationPage.unread'),
    value: 'unread',
}]);
const iDataScope = ref('all');

const sDateFormat = computed(() => {
    let format = 'DD/MM/YYYY HH:mm:ss';
    if (useI18n().locale.value == 'cn') {
        format = 'YYYY/MM/DD HH:mm:ss';
    }
    return format;
});
const loading = ref([]);
// 图片加载失败显示默认图片
const handleImageError = (e, index) => {
    e.target.src = defaultImage;
    //   setTimeout(() =>{
    //     loading.value[index] = false;
    //   },1000)

};
const handleImageLoad = (idx) => {
    // 优化 图片加载
    setTimeout(() => {
        loading.value[idx] = false;
    }, 1000)
};

// 检查内容是否超出 2 行
const initTextEl = (el, index) => {
    if (!el) return;
    nextTick(() => {
        // 检测是否超出 2 行
        if (oActive.value.aNotiList[index].isExpanded) {
            oActive.value.aNotiList[index].showExpandButton = oActive.value.aNotiList[index].isExpanded;
        } else {
            oActive.value.aNotiList[index].showExpandButton = el.scrollHeight > el.clientHeight;
        }

    });
};

const handleHide = () => {
    emits('update:show', false)
}

const changeTab = (idx: number) => {
    iTabActive.value = idx;
    const toGetData = (
        !oActive.value.aNotiList.length // 没数据
        || oActive.value.typeLastSearch != iDataScope.value // 类型发生了变化
    )
    if (!toGetData) return;
    oActive.value.aNotiList.splice(0, 1 / 0);
    oActive.value.pending = true;
    oActive.value.noMoreNotifications = false;
    initData();
};

const oActive = computed(() => {
    return aTabList[iTabActive.value];
});

const handleSelectGame = (val) => {
    console.log('新类型：', val);
    // ↓ 变换类型时这里需要先清空，
    oActive.value.aNotiList.splice(0, 1 / 0);
    initData();
}
const isError = ref(false)
const iTimeOut = 5 * 1_000;

const initData = async () => {
    const iNow = Date.now();
    const oCurTab = aTabList[iTabActive.value];
    oCurTab.requestID = iNow;
    const id = oCurTab.aNotiList.at(-1)?._id ?? -1; 
    const typeLastSearch = iDataScope.value;

    try {
        const timeouts = setTimeout(() => {
            isError.value = true;
            console.error('请求超时（超过5秒未响应）');
        }, iTimeOut);

        // 发起请求
        const res = await EMIT_MAIL_INFO({
            id,
            pagenum: 10,
            type: oCurTab.iTypeMark,
            ...(typeLastSearch == 'all' ? {} : { isread: 0 }),
        }) as any;
        // if (import.meta.env.DEV_MODE && Math.random() < 0.3){
        //     console.log('人造超时'); 
        //     await Sleep(iTimeOut * 1.5) // 人造超时 
        // }
        // 请求成功时清除超时计时器
        clearTimeout(timeouts);
        oCurTab.pending = false;
        
        if (!res || !res.response || res.error) {
            return console.error('接口出错');
        }else{
            isError.value = false; // 好歹是请求完毕了，状态归正 
        }
        
        console.log(`消息如下（始于 ${id}）↓\n`, deepCopy(res.response));
        if (oCurTab.requestID != iNow) {
            return console.log('放弃赋值');
        }
        if (res.response.length) {
            oCurTab.aNotiList.push(...res.response);
            oCurTab.typeLastSearch = typeLastSearch;
        } else {
            oCurTab.noMoreNotifications = true;
        }
        
    } catch (error) {
        // 错误处理
        isError.value = true;
        oCurTab.pending = false;
        console.error('请求失败:', error?.message || error);
    }
}

const watchTouchBottom = async () => {
    const atBottom = isScrolledToBottom();
    if (!atBottom) return;
    if (oActive.value.pending) {
        return console.log('触底，为了 “防抖” 放弃了查询');
    }
    if (oActive.value.noMoreNotifications) {
        return console.log('因无更多数据，放弃查询');
    }
    oActive.value.pending = true;
    console.log('触底，查询中……');
    await initData(); // 追加数据 
    oActive.value.pending = false;
}

function isScrolledToBottom() {
    if (!oPageWrap.value) return;
    // 获取当前滚动条垂直方向的偏移量
    const scrollTop = oPageWrap.value.scrollTop;
    // 获取视口高度
    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    // 获取文档的总高度
    const documentHeight = Math.max(
        oPageWrap.value.scrollHeight,
        oPageWrap.value.offsetHeight,
        oPageWrap.value.clientHeight,
    );
    const bResult = (
        // 追加的数值是用于提前触发触底事件 
        (scrollTop + windowHeight + 200) >= documentHeight
    );
    // 判断是否已经滚动到底部
    return bResult;
}

function scrollToTop() {
    if (!oPageWrap.value) return;
    oPageWrap.value.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
    });
}

async function fnJoin(oTarget) {
    console.log('立即加入：', deepCopy(oTarget));
    // ↓ 在上方先设为已读 
    fnMarkOneAsRead(oTarget);
    await Sleep(100); // 等上方请求发送完毕再跳转 
    const { link } = oTarget;
    location.href = link;
}

async function fnMarkOneAsRead(oTarget) {
    const res = await EMIT_MAIL_SET_READ({
        ids: [oTarget._id],
        type: oTarget.type,
    });
    if (Reflect.has(res, 'response')) {
        oTarget.is_read = 1; // 已读 
    } else {
        console.error('设定已读未成功');
    }
    console.log('设为已读：', deepCopy(oTarget));
    console.log('设定结束：', deepCopy(res));
    userStore.updateUnreadCount();
}

async function fnMarkAllAsRead() {
    Dialog.create({
        title: $tFn('Note'),
        message: $tFn('notificationPage.setAllAsReadConfirm'),
        style: { 'width': '300px' },
        transitionHide: 'none', // 关闭退场动画 
        class: 'dialog-for-cancel-set-all-as-read-h589i3v2',
        ok: {
            label: $tFn('commonInfo.confirm'),
        },
        cancel: {
            label: $tFn('Cancel'),
            color: 'white',
            TextColor: 'white',
        },
    }).onOk(
        toSet
    );
    // ↓ 执行方法 
    async function toSet() {
        const res = await EMIT_MAIL_SET_READ({
            type: oActive.value.iTypeMark,
            isReadAll: 1,
        });
        if (Reflect.has(res, 'response')) {
            oActive.value.aNotiList.forEach(cur => {
                cur.is_read = 1; // 已读 
            });
        } else {
            console.error('设定已读未成功');
        }
        userStore.updateUnreadCount();
    }
}

const fnListenerSwitch = (bStatus)=>{
    if (import.meta.server || !oPageWrap.value) {
        return;
    }
    const sEvent = (
        bStatus
        ? 'addEventListener'
        : 'removeEventListener'
    );
    console.log(`[${iST}] 事件：`, sEvent);
    oPageWrap.value[sEvent]('scroll', watchTouchBottom);
}

// ↓ 在窗口打开/关闭时启动和取消监听 
watch(
    ()=>props.show,
    fnListenerSwitch,
    { immediate: true },
);

onMounted(async () => {
    await initData();
    fnListenerSwitch(true);
    // ↓ 可以在此更新一下数值 
    userStore.updateUnreadCount();
    loading.value = oActive.value.aNotiList.map(() => true);
});

onBeforeUnmount(() => {
    fnListenerSwitch(false);
});


/**
 * 仅用于测试
 */
function fnGetTestList() {
    const obj01 = {
        "_id": 25, // '邮件ID',
        "title": '邮件标题',
        "type": 1, // '邮件类型 0系统 1个人',
        "content": '内容',
        "status": 1, // '状态，暂时都是1正常',
        "picture": 'http://13.215.6.142:8886/upload_file/2025-04-07/d903ke2fzhr6ksymtn.png',
        "date": '2025-04-14T08:30:44.000Z',
        "is_read": 0, // 0、未读 1、已读
        "link": "http://www.baidu.com", // 跳转地址
    };
    const lang = Math.random() * 10 + 9;
    const sTime = new Date().toLocaleTimeString();
    const arr = Array(~~lang).fill(1).map((cur, idx) => {
        const newOne = {
            ...obj01,
            title: `${sTime}_${idx + 1}_⭕_自然界（Natural world），一般是指包括人类社会在内的整个客观世界`,
            is_read: idx % 2 ? 1 : 0,
            content: '环境指以人为中心的一切客观事物的总和。环境可区分为自然环境和社会环境。自然环境指大气层、水、土壤岩石和生物圈。社会环境指人类的创造物，例如工农业、城市、交通、娱乐场所、文物，的自然数，除了1和它自身外，不能被其他自然数整除的数叫做质数；否则称为合数（规定1既不是质数也不是合数）。',
            date: new Date().toLocaleString(),
        };
        newOne.title = newOne.title.repeat(idx % 2 ? 2 : 1);
        return newOne;
    });
    return arr;
}

</script>

<style lang="scss" scoped src="./style/notificationPage.scss"></style>
<style lang="scss">
.q-card.dialog-for-cancel-set-all-as-read-h589i3v2 {
    button.bg-white .block {
        color: var(--q-primary);
    }
}
</style>
